"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var cache_module_1 = require("./cache.module");
exports.CacheModule = cache_module_1.CacheModule;
var cache_service_1 = require("./cache.service");
exports.CacheService = cache_service_1.CacheService;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/obscache/dist/index.js
// module id = 434
// module chunks = 0